module.exports = __webpack_public_path__ + "static/media/icon-header-projects.1e42a519.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/HeaderNoLogout/assets/icon-header-projects.svg
// module id = 1850
// module chunks = 193